import i18n from "../../services/localization-service/i18n";
import { BaseActions, ActionMenuItem  } from "../action-menu/ActionMenuItem";
import { IReferenceNotificationListDTO } from "../../services/setpoint-administration-service/Models";
import { VirtualizedListItem } from "../virtualized-list/VirtualizedList";
import { AddIcon } from "../action-menu/ActionMenuIcons";


export type AlarmSetpointNotificationListItem = IReferenceNotificationListDTO & VirtualizedListItem;

export enum FormNotificationListsActions  {
    Add = 'add',
    Edit = 'edit'
}

export type FormNotificationListsActionItem = {
    action: FormNotificationListsActions | BaseActions | string
} & ActionMenuItem;

export const notificationListActionItems: FormNotificationListsActionItem[] = [{
    label: i18n.t("buttons.newNotificationList"),
    icon: AddIcon,
    action: FormNotificationListsActions.Add,
    order: 0
}];


export type NotificationListsFormType = {

    notificationLists: IReferenceNotificationListDTO[];
};



const FormNotificationListsUtils = {
    
    filterNotificationLists: (data: IReferenceNotificationListDTO[], 
        filter: string,
        organizationID: number | undefined
    ) : IReferenceNotificationListDTO[] => {

    return data.filter(o => filter.trim() === '' ||
                            o.name.toLowerCase().indexOf(filter.trim().toLowerCase()) !== -1)
                    .filter(o => o.organizationID === organizationID || organizationID === undefined);
    }
}

export default FormNotificationListsUtils;
